import {getStowPackageMetrics} from "../resources/StowResource";
import {Resource, StowPackageMetric} from "../enums";
import {FEATURES, TOTAL, TRUE} from "../constants";
import {getSidelineRangeFilter} from "../Utility";

export const LOAD_METRICS_FOR_CART_CALL_BEGIN = "LOAD_METRICS_FOR_CART_CALL_BEGIN";
export const LOAD_METRICS_FOR_CART_CALL_FAILURE = "LOAD_METRICS_FOR_CART_CALL_FAILURE";
export const LOAD_STOW_PACKAGE_METRICS_FOR_CART = "LOAD_STOW_PACKAGE_METRICS_FOR_CART";

const loadMetricsForCartCallBegin = () => ({
    type: LOAD_METRICS_FOR_CART_CALL_BEGIN
});

const loadMetricsForCartCallFailure = () => ({
    type: LOAD_METRICS_FOR_CART_CALL_FAILURE
});

const loadStowPackageMetricsForCart = (stowPackageMetricsMap) => ({
    type: LOAD_STOW_PACKAGE_METRICS_FOR_CART,
    stowPackageMetricsMap
});

export const getStowPackageMetricsForCart = (nodeId, featureStatus, floorLocation, reInductDate) => {

    return async (dispatch) => {
        dispatch(loadMetricsForCartCallBegin());
        try {
            const request = constructStowPackageMetricsRequest(nodeId, featureStatus, floorLocation, reInductDate);
            const stowPackageMetricsMap = await getStowPackageMetrics(request);
            if (stowPackageMetricsMap) {
                // aggregation not required
                delete stowPackageMetricsMap[TOTAL];
                dispatch(loadStowPackageMetricsForCart(stowPackageMetricsMap));
            } else {
                dispatch(loadMetricsForCartCallFailure());
            }
        } catch (error) {
            dispatch(loadMetricsForCartCallFailure());
        }
    }
}

const constructStowPackageMetricsRequest = (nodeId, featureStatus, floorLocation, reInductDate) => {

    if (featureStatus && featureStatus[FEATURES.SIDELINE_STOW_V2]) {
        return {
            groupBy: Resource.CART,
            filters: {
                NODE: [nodeId],
                SIDELINE_V2: [TRUE],
                FLOOR_LOCATION: [floorLocation]
            },
            rangeFilters:[getSidelineRangeFilter(reInductDate)],
            metrics: [
                StowPackageMetric.CURRENT_STOWED_COUNT
            ]
        }
    }

    return {
        groupBy: Resource.CART,
        filters: {
            NODE: [nodeId],
            SIDELINE: [TRUE],
            FLOOR_LOCATION: [floorLocation],
            SIDELINE_UNTIL_TIME: [reInductDate]
        },
        metrics: [
            StowPackageMetric.CURRENT_STOWED_COUNT
        ]
    }
}



// WEBPACK FOOTER //
// ./src/actions/CartActions.js